import {
  NODE_TYPE as NT,
  MARK_TYPE as MT,
} from 'shared/constants/slate';


import { topLevelBlocksInSel } from './topLevelBlocksInSel';


export const toggleMarkWorkaround = (change, type) => {
  if (!Object.values(MT).includes(type)) {
    return change;
  }

  const topLevelBlocks = topLevelBlocksInSel(
    change.value, { withTrim: true }
  );

  // Because we have some top level blocks that
  // forbid marks inside (enforced via normalization rules),
  // this gets in the way of toggling marks when selection
  // is over one of these top level blocks. So, just apply
  // targetMark first before `toggleMark` to nullify this.
  // XXX(tyu): Just headline for now..
  const workaroundFor = [NT.headline];

  const { selection: sel } = change.value;

  topLevelBlocks
    .filter(block => (
      workaroundFor.includes(block.type)
    ))
    .forEach(block => {
      const range = sel
        .collapseToStartOf(block)
        .extendToEndOf(block);

      // So { normalize: false } option is important b/c
      // otherwise it gets normalized right away..?!
      change.addMarkAtRange(
        range, type, { normalize: false }
      );
    });

  // Normalize here after toggling marks.
  // This fixes the bug where formatting inside headline
  // alone doesn't trigger normalization.
  return change
    .toggleMark(type)
    .normalizeDocument()
    .focus()
}



// WEBPACK FOOTER //
// ./src/components/slate/utils/toggleMarkWorkaround.js